// extracted by mini-css-extract-plugin
export default {"titulos":"TextosTitulos_titulos__hsbCR","titulo":"TextosTitulos_titulo__XwlZi","subTitulo":"TextosTitulos_subTitulo__c-83G"};